import { axiosInstance } from "../../../utils";

const actions = {
    CREATE_OR_UPDATE_PRODUCT_GROUP_REQUESTED: 'CREATE_OR_UPDATE_PRODUCT_GROUP_REQUESTED',
    CREATE_OR_UPDATE_PRODUCT_GROUP_SUCCEEDED: 'CREATE_OR_UPDATE_PRODUCT_GROUP_SUCCEEDED',
    CREATE_OR_UPDATE_PRODUCT_GROUP_FAILED: 'CREATE_OR_UPDATE_PRODUCT_GROUP_FAILED',

    addOrUpdateProductGroup: (data = undefined) => {
        return {
            type: actions.CREATE_OR_UPDATE_PRODUCT_GROUP_REQUESTED,
            payload: data
        }},

    createOrUpdateProductGroup: async (data = undefined) => {
        let url = `items_groups/create`;

        let bodyFormData = new FormData();

        if (data.name) bodyFormData.set('name', data.name);
        if (data.name_ar) bodyFormData.set('name_ar', data.name_ar);
        if (data.fields) bodyFormData.set('fields', JSON.stringify(data.fields));

        if(data._id) {
            url = `items_groups/` + data._id
            try {
                const productGroup = await axiosInstance.put(url, data);
                return productGroup.data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const productGroup = await axiosInstance.post(url, data);
                return productGroup.data;
            } catch (error) {
                throw error;
            }
        }
    }
};

export default actions;
